export default __webpack_public_path__ + "static/char-s-36-en-e6be5a896dae5da1c8bfb3403d0ec5cd.webp";